// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox__container___2IDlh","checkbox":"checkbox__checkbox___2mfYm","checked":"checkbox__checked___2xTUv"};